import React, { useState } from 'react'

import { ReactComponent as RightCarat } from '../../assets/rightCarat.svg'
import { ReactComponent as DownCarat } from '../../assets/downCarat.svg'
import ExpandedPaymentSchedule from './ExpandedPaymentSchedule'
import roundToTwo from '../../utils/RoundToTwo'

import './PaymentBuilder.css'

export default function PaymentStream({
	expandPaymentDetails,
	expandStream,
	handleExpandStream,
	grouped,
	id,
	inputData,
}) {
	const [expandMe, setExpandMe] = useState(false)

	let dollarTotal = 0
	let monthTotal = Number(inputData[id]['paymentAmount'])
	let annual = inputData[id]['paymentFrequency'] === '3' ? true : false
	let increaseAmount = Number(inputData[id]['escalationAmount'])
	let increaseType = inputData[id]['escalation']
	let increaseFrequency = Number(inputData[id]['escalationFrequencyAmount'])
	let frequencyType = Number(inputData[id]['escalationFrequency'])
	let counter = 0
	let increaseFrequencyType

	if (frequencyType === 1) {
		increaseFrequency === 1
			? (increaseFrequencyType = 'month')
			: (increaseFrequencyType = 'months')
	} else if (frequencyType === 2) {
		increaseFrequency === 1
			? (increaseFrequencyType = 'quarter')
			: (increaseFrequencyType = 'quarters')
	} else if (frequencyType === 3) {
		increaseFrequency === 1
			? (increaseFrequencyType = 'year')
			: (increaseFrequencyType = 'years')
	}

	Object.values(grouped).forEach((payment) => {
		payment.forEach((month) => {
			dollarTotal += month.amount
			if (month.amount !== 0) {
				counter += 1
			}
		})
	})

	const formatter = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
	})

	return (
		<>
			<div
				className={
					id === 0
						? 'schedule-inner-content-header-rounded'
						: 'schedule-inner-content-header'
				}
				onClick={
					expandStream
						? () => handleExpandStream()
						: () => setExpandMe(!expandMe)
				}
			>
				<div>
					<div className='inline-block'>
						{expandStream ||
						(expandMe && !expandStream) ||
						(expandMe && expandStream) ? (
							<DownCarat />
						) : !expandMe && expandStream ? (
							<RightCarat />
						) : (
							<RightCarat />
						)}
					</div>
					{annual ? (
						<span className='padding-left'>
							<b>Payment Stream {id + 1}: </b> {formatter.format(monthTotal)}{' '}
							per year for {counter} {counter === 1 ? 'payment' : 'payments'}
							{increaseAmount === 0 || increaseAmount === ''
								? `.`
								: ` increasing by ${
										increaseType === 'Percent'
											? `${roundToTwo(increaseAmount)}% `
											: `${formatter.format(increaseAmount)}`
								  } every ${
										increaseFrequency === 0 || increaseFrequency === 1
											? `${increaseFrequencyType}.`
											: `${roundToTwo(
													increaseFrequency
											  )} ${increaseFrequencyType}.`
								  }`}
						</span>
					) : (
						<span className='padding-left'>
							<b>Payment Stream {id + 1}: </b> {formatter.format(monthTotal)}{' '}
							per month for {counter} {counter === 1 ? 'payment' : 'payments'}
							{increaseAmount === 0 || increaseAmount === ''
								? `.`
								: ` increasing by ${
										increaseType === 'Percent'
											? `${roundToTwo(increaseAmount)}% `
											: `${formatter.format(increaseAmount)}`
								  } every ${
										increaseFrequency === 0 || increaseFrequency === 1
											? `${increaseFrequencyType}.`
											: `${roundToTwo(
													increaseFrequency
											  )} ${increaseFrequencyType}.`
								  }`}
						</span>
					)}
				</div>
				<div className='padding-left-big'>
					<b>{formatter.format(dollarTotal)}</b>
				</div>
			</div>
			<div className='schedule-inner-content-total'>
				{expandStream ||
				(expandMe && !expandStream) ||
				(expandMe && expandStream) ? (
					<>
						{Object.keys(grouped).map((schedule, index) => {
							return (
								<ExpandedPaymentSchedule
									key={index}
									id={index}
									year={schedule}
									payments={grouped[schedule]}
									expandPaymentDetails={expandPaymentDetails}
								/>
							)
						})}
					</>
				) : null}
			</div>
		</>
	)
}
